import { render } from "./ProfileReviewItem.vue?vue&type=template&id=4e27518a"
import script from "./ProfileReviewItem.vue?vue&type=script&lang=js"
export * from "./ProfileReviewItem.vue?vue&type=script&lang=js"

import "./ProfileReviewItem.vue?vue&type=style&index=0&id=4e27518a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__